import EVENG from "public/hosted-emulators/eve-ng.webp";
import GNS from "public/hosted-emulators/gns.webp";
import CML from "public/hosted-emulators/cml.webp";
import { HOSTED_EMULATOR_ROUTES, MAIN_ROUTES, SERVICES_ROUTES } from "@/constants/routes";
import { BiCloudUpload, BiNetworkChart } from "@onemind-services-llc/react-icons-ng/bi";
import {
  TbOutlineReportAnalytics,
  TbOutlineSettingsAutomation,
  TbOutlineCloudComputing,
} from "@onemind-services-llc/react-icons-ng/tb";

export const HOSTED_EMULATORS_LIST = [
  {
    content: [
      "Build and validate complex networks with our cloud-hosted GNS3 platform. Create enterprise-grade network simulations, test router configurations, and design virtual network environments - all without hardware. Perfect for certification practice labs and professional network testing.",
    ],
    image: GNS,
    path: `${MAIN_ROUTES.SERVICES}${SERVICES_ROUTES.HOSTED_EMULATORS}${HOSTED_EMULATOR_ROUTES.GNS}`,
    title: "HOSTED GNS3",
    btnText: "Explore GNS3",
    test: "gns3",
  },
  {
    content: [
      "Experience advanced network emulation with our hosted EVE-NG environment. From router simulation to complete network lab tools, EVE-NG delivers professional-grade virtual networking capabilities. Ideal for complex testing scenarios, multi-vendor environments, and enterprise network validation.",
    ],
    image: EVENG,
    path: `${MAIN_ROUTES.SERVICES}${SERVICES_ROUTES.HOSTED_EMULATORS}${HOSTED_EMULATOR_ROUTES.EVE_NG}`,
    premiumPartner: true,
    title: "HOSTED EVE-NG",
    btnText: "Explore EVE-NG",
    test: "eve-ng",
  },
  {
    content: [
      "Deploy precise network simulation software with hosted Cisco Modeling Labs 2.0. Create accurate virtual network designs, test production configurations, and validate architectures in a secure cloud environment. The most trusted platform for Cisco-focused network testing and certification preparation.",
    ],
    image: CML,
    path: `${MAIN_ROUTES.SERVICES}${SERVICES_ROUTES.HOSTED_EMULATORS}${HOSTED_EMULATOR_ROUTES.CML}`,
    title: "HOSTED CML 2.0",
    btnText: "Explore CML 2.0",
    test: "cml",
  },
];

export const CAPABILITIES_LIST = [
  {
    title: "Network Design",
    subtitle:
      "Full topology creation and modification . Instant access to professional simulation tools",
    icon: BiNetworkChart,
  },
  {
    title: "Complete virtual lab environment setup",
    subtitle: "Isolated, secure testing infrastructure",
    icon: TbOutlineReportAnalytics,
  },
  {
    title: "Enterprise-grade hardware resources",
    subtitle: "",
    icon: TbOutlineSettingsAutomation,
  },
  {
    title: "Support for custom network images and configurations",
    subtitle: "",
    icon: BiCloudUpload,
  },
  {
    title: "Advanced router and switch emulation",
    subtitle: "",
    icon: TbOutlineCloudComputing,
  },
];
